document.addEventListener('DOMContentLoaded', () => {
	const block = document.querySelector('.block--partners');

	if (block) {
		const slider = block.querySelector('.block--partners__slider');
		const buttonPrev = block.querySelector('.block--partners__control-item--prev');
		const buttonNext = block.querySelector('.block--partners__control-item--next');

		// eslint-disable-next-line no-unused-vars
		const swiper = new Swiper(slider, {
			slidesPerView: 'auto',
			spaceBetween: 16,
			navigation: {
				nextEl: buttonNext,
				prevEl: buttonPrev,
			},
			breakpoints: {
				768: {
					slidesPerView: 5,
					spaceBetween: 32,
					navigation: {
						nextEl: buttonNext,
						prevEl: buttonPrev,
					},
				},
			},
		});
	}
});
